export const datasetDetailsTabsContainerStyles = {
  mt: '2rem',
  width: '100%',
  pb: '3rem',
};

export const iconButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
};

export const detailsPageHeaderContainer = {
  display: 'flex',
  gap: '4rem',
  alignItems: 'center',
};

export const detailsPageContainer = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  p: 3,
};

export const datasetDetailsPanelWrapperStyles = {
  p: 2,
  border: '1px solid #00000033',
  borderRadius: '8px',
  pr: '20%',
};

export const moreButtonStyles = {
  color: 'electricBlue.main',
  textTransform: 'capitalize',
  flex: 1,
  minWidth: '100%',
  p: 1,
};
